import React from 'react'
import { BlockMain } from '@blocks/BlockMain'
import { DisclaimerMain } from '@shared/components/disclaimer-main'
import { ApplicationForms } from '@shared/components/forms/application'
import { scrollToApplicationForm } from '@shared/components/forms/application/cross'
import PageAnimation from '@shared/components/page-animation'
import { Section } from '@shared/components/section'
import { AppSection } from '@shared/components/sections/app'
import { Journal } from '@shared/components/sections/journal'
import { Rate } from '@shared/components/sections/rate'
import { RiskPoints } from '@shared/components/sections/riskPoints'
import { StepsNoSection } from '@shared/components/sections/steps'
import { YouTube } from '@shared/components/sections/youtube'
import { PagesPath, pagesTitles } from 'data/pages-titles'

import { HelpBusinesses } from './sections/helpBusinesses'
import { stepsData } from './sections/steps/data'

import styles from './style.module.scss'

interface Props {
	ratePoints?: string[]
	minLoan?: number
}

export const View = ({ ratePoints, minLoan }: Props) => (
	<PageAnimation>
		<BlockMain
			adornmentClassname={styles.mainAdornment}
			imageAdornmentWrapClassName={styles.imageAdornment}
			data={{
				title: pagesTitles[PagesPath.moneyForBusiness].mainBlockTitle,
				textItems: [
					'Не требуется финансовая отчётность компании',
					'Возможна быстрая выдача за 1 день',
					'Можно оформить как физлицо',
					'Лояльны к кредитной истории',
				],
				footDisclaimer: <DisclaimerMain />,
				buttonText: 'Рассчитать кредит',
				faceImageName: {
					mobile: 'Julia_mobile.png',
					default: 'Julia_desc.png',
				},
				imageAlt: 'Юлия, руководитель отдела по работе с клиентами',
			}}
			buttonProps={{
				onClick: scrollToApplicationForm,
			}}
		/>
		<Section className={styles.helpBusinesses} fullWidth>
			<HelpBusinesses />
		</Section>
		<Section className={styles.appWrap} fullWidth>
			<Rate points={ratePoints} />
			<AppSection />
		</Section>
		<Section className={styles.stepsWrap} fullWidth>
			<h2 className={styles.sectionTitle}>3 простых шага для получения кредита</h2>
			<StepsNoSection stepTextStyles={styles.extraTextStyles} steps={stepsData} />
			<h2 className={styles.sectionTitle}>Вы не рискуете</h2>
			<RiskPoints />
		</Section>
		<Section className={styles.youtubeWrap} fullWidth>
			<Journal />
			<YouTube />
		</Section>
		<ApplicationForms.Cross
			processBarText='Вероятность одобрения кредита'
			formTitle='Заявка на кредит для бизнеса'
			minLoan={minLoan}
		/>
	</PageAnimation>
)
